/**
 * Country Select
 */
class CountrySelect {
    static get elementID() {
        return '#countrySelect';
    }
    /**
     * @param {[{country: string, continent: string}]} countries List of countries
     * @param modal
     */
    static build(countries, modal = false) {

        let i18nSrc = new I18n ({'de': {'other_countries' : 'Andere Länder'},'en': {'other_countries' : 'Other countries'}}, $('html').attr('lang') || 'de');

        countries.forEach((country) => {
            if (modal) {
                if (country.country === 'Germany') {
                    $(CountrySelect.elementID).append($('<option/>', {
                        value: country.country,
                        text: country.country
                    }));
                }
            } else {
                $(CountrySelect.elementID).append($('<option/>', {
                    value: country.country,
                    text: country.country
                }));
            }

        });

        if (!modal) {
            $(CountrySelect.elementID).append($('<option/>', {
                value: 'HQ',
                text: i18nSrc.get('other_countries')
            }));
        }
    }

    /**
     * @param {[]} countries List of countries
     */
    static buildByArray (countries) {

        countries.forEach((country) => {
            $(CountrySelect.elementID).append($('<option/>', {
                value: country,
                text: country
            }));
        });

    }
    /**
     * Find unique countries ...
     * @param data
     * @returns {Array}
     */
    static extract(data) {
        let countries = [];

        data.forEach((item) => {
            if (countries.indexOf(item.country) === -1) {
                countries.push(item.country)
            }
        });

        return countries.sort();
    }
}

export default CountrySelect;
